import collect from 'collect.js';
import { Client } from '../../types/menu';
import { ProductIdentifier } from '../../types/constants';

const names = {
  [ProductIdentifier.Vegan]: 'Vegan',
  [ProductIdentifier.Vegetarian]: 'Vegetarian',
  [ProductIdentifier.GlutenFree]: 'Gluten free',
  [ProductIdentifier.DairyFree]: 'Dairy free',
  [ProductIdentifier.Halal]: 'Halal',
  [ProductIdentifier.Spicy]: 'Spicy',
};

export default function useProductIdentifiers(product: Client.Product) {
  const identifiers = product.identifiers;

  const isVegan = identifiers.includes(ProductIdentifier.Vegan);
  const isVegetarian = identifiers?.includes(ProductIdentifier.Vegetarian);

  // Vegan overrides vegetarian
  const filtered = collect(identifiers).when(isVegan && isVegetarian, (collection) =>
    collection.reject((item) => item === ProductIdentifier.Vegetarian),
  );

  return {
    identifiers,
    isVegan,
    isVegetarian,
    names: filtered.map((item: ProductIdentifier) => names[item] ?? item),
  };
}
